import * as R from 'ramda'

export const transformCljGroupedLog = cljGroupedLog => {
  return cljGroupedLog.reduce((acc, [data, entities], index) => {
    const key = R.cond([
      [
        metaData => R.equals(R.prop(':type', metaData), ':before-start'),
        R.always('beforeStart')
      ],
      [
        metaData => R.equals(R.prop(':type', metaData), ':after-end'),
        R.always('afterEnd')
      ],
      [R.T, metaData => R.prop(':start-string', metaData)]
    ])(data)

    const actionCount = R.length(entities)
    const transformedEntities = (entities || []).reduce((_acc, e, i) => {
      const prevPeriodKey = R.path(
        [index - 1, 0, ':start-string'],
        cljGroupedLog
      )

      const prevPeriodCumulativePointsEarned = R.pathOr(
        0,
        [prevPeriodKey, 'cumulativePointsEarned'],
        acc
      )

      _acc.push({
        entityAttr: e[':entity-type'],
        hitMax: e[':points-earned'] !== e[':points'],
        entity: {
          ...e,
          points: e[':points'],
          localTime: e[':local-time'].rep
        },
        config: e[':config'],
        points: e[':points'],
        tzSlug: e[':tz-slug'],
        timezone: e[':timezone'],
        pointsEarned: e[':points-earned'] || 0,
        cumulativePointsEarned:
          prevPeriodCumulativePointsEarned +
          R.sum(R.map(R.propOr(0, ':points-earned'), R.take(i + 1, entities)))
      })

      return _acc
    }, [])
    const weeklyPointsEarned = data.cappedTotal
    const weeklyPoints = data.uncappedTotal
    const weeklyMax = data[':grading-period/weekly-max'] || 0
    const period = {
      ':db/id': data[':db/id'],
      ':grading-period/weekly-max': weeklyMax,
      ':grading-period/start-date': data[':grading-period/start-date'],
      ':grading-period/end-date':
        index === cljGroupedLog.length - 2
          ? data[':grading-period/end-date'] - 1
          : data[':grading-period/end-date']
    }

    acc[key] = {
      actionCount,
      entities: transformedEntities,
      period,
      cumulativePointsEarned: R.sum(
        R.map(R.path([0, 'cappedTotal']), R.take(index + 1, cljGroupedLog))
      ),
      weeklyPointsEarned,
      weeklyPoints,
      weeklyMax,
      pointAdjustment: data.pointAdjustment || 0
    }
    return acc
  }, {})
}
